module.exports = __webpack_public_path__ + "img/C550.7b1af0fa.jpg";